<template>
  <div class="policy-box" v-if="getGuaranteeId(room.room_type_id, room.rate.id)">
    <span class="label-no-height">{{ $t('lbl_guarantee_policy') + ' - ' + getGarantyName(room.room_type_id, room.rate.id)}}</span>
    <div class="text-grey m-t-10 ">{{  translateValues('NO_OBJECT_CODE', propertyDetails.guarantee_policy, 'PROPERTY_HEADER', null, 'guarantee_policy', 'optional') }}</div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import { translateDynamicContent } from "@/services/utilities.service";


export default {
  name: 'PolicyBox',
  props: ['room', 'roomIndex'],
  computed: {
    ...mapState({
      propertyDetails: state => state.property.details,
      rwa_data: state => state.rwa_data,
      multi_lingual_dynamic_fields: state => state.multi_lingual_dynamic_fields,
      property_language_code: state => state.property.details.language
    }),
  },
  methods: {

    selectedRateDetails(room_type_id,rateId){
      return this.rwa_data.rate_details.find(rd=>rd.room_type_id === room_type_id).rate_codes.find(r=> r.id === rateId)
    },
    getGuaranteeId(room_type_id,rateId){
      return this.selectedRateDetails(room_type_id,rateId).guarantee_type_ids ?  
            this.selectedRateDetails(room_type_id,rateId).guarantee_type_ids[0] : []
    },
    getGarantyName(room_type_id,rateId){
      let guarantee =  this.rwa_data.guarantee_types?.find(c=>c.id === this.getGuaranteeId(room_type_id,rateId))
      return this.translateValues(guarantee.code, guarantee.name, 'GUARANTEE_TYPES', guarantee.id, 'name') || ''
    },//guarantee_type_ids
    translateValues(object_code, value, object_type, object_id, field_name, optional) {
      return translateDynamicContent(this.multi_lingual_dynamic_fields, object_code, value, object_type, this.property_language_code, object_id, field_name, optional)
    }
  },
}
</script>

<style lang="scss" scoped>
.policy-box {
  font-size: 14px;
    border: solid #dadada 1px;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 10px;
}
</style>
